import { Injectable } from '@angular/core';
import { Messaging } from '@angular/fire/messaging';
import { getToken, MessagePayload, onMessage } from 'firebase/messaging';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  messageSource = new BehaviorSubject<MessagePayload | null>(null);
  foregroundMessage$ = this.messageSource.asObservable();

  constructor(
    private messaging: Messaging
  ) {
    this.listenToForegroundMessages();
  }

  private listenToForegroundMessages(): void {
    onMessage(this.messaging, (payload) => {
      this.messageSource.next(payload);
    });
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    try {
      const isPermissionGranted = await this.getNotificationPermission();

      if (!isPermissionGranted) {
        return null;
      }

      return await this.getFCMToken();
    } catch {
      return null;
    }
  }

  async getFCMToken(): Promise<string | null> {
    const token = await getToken(this.messaging, {
      vapidKey: environment.firebaseVapidKey
    });

    return token ?? null;
  }

  async getNotificationPermission(): Promise<boolean> {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
}
